"use strict";

$(".product-form__cart-submit-gc").click(function (i) {
  // First, check for errors...
  if (i.preventDefault(), "disabled" != $(this).attr("disabled")) {
    var errors = checkGCInputErrors();

    if (errors) {
      return;
    }

    var att = pinkblush.cartobj.variantid;
    var qty = 1;
    var props = {
      Recipient: $("#to-name").val(),
      From: $("#from-name").val(),
      Email: $("#to-email").val(),
      Message: $("#tmessage-gc").val(),
      IsFinalSale: 1
    };

    if (att == "-1" || att == 0) {
      $(".atc-error").html("Please Select a size!");
    } else {
      $("body").addClass("loading");
      CartJS.addItem(att, qty, props, {
        "success": function success(data, textStatus, jqXHR) {
          //console.log(data);
          
          $("#quickshop-drawer").removeClass("active");
          setTimeout(function () {
            $("body").removeClass("loading");
            $("body").addClass("showOverly");
            $(".block-cart").addClass("active");
            calculateFreeShippingBar();
            animateFreeShippingBar();
          }, 400);
        },
        "error": function error(jqXHR, textStatus, errorThrown) {
          //console.log(jqXHR.responseJSON.description);
          var errormsg = "Please select a size to add to your cart.";
          var errortitle = "Oops!";

          if (jqXHR.responseJSON.description.indexOf("are in your cart") > -1) {
            errortitle = "We Love This Style, Too!";
            errormsg = "All available units of this style are already in your cart. <div class='btn d-block'>Keep Shopping</div>";
          }

          $("body").removeClass("loading");
          $(".error-title").html(errortitle);
          $(".error-message").html(errormsg);
          $(".error-message .btn").on("click tap", function () {
            $("#errorDrawer").fadeOut(200);
            $("body").removeClass("loading showOverly");
          });
          $("body").addClass("showOverly");
          $("#errorDrawer").fadeIn(500);
          drawerTimeout = setTimeout(function () {
            $("body").removeClass("loading showOverly"), $("#errorDrawer").fadeOut(200);
          }, 6000);
        }
      });
      return;
    }
  }
});
$(".gc-style.swatchLbl").on("click tap", function (e) {
  var style = $(this).data("style");
  console.log(style);
  $(".amount-swatches").removeClass("hide");
  var selector = ".gc-style-" + style;
  $(".amount-swatches-gc").addClass("hide");
  $(selector).removeClass("hide"); // Get selected Amount

  $('input[name="option-amount"]').prop('checked', false); // If a previous amount is elected, select it.

  if (typeof pinkblush.cartobj.gc_amount != "undefined") {
    var amount = pinkblush.cartobj.gc_amount;
    var inputSelector = selector + ' label[data-price="' + amount + '"]';
    console.log(inputSelector);
    $(inputSelector).click();
  }
});
$(document).ready(function () {
  gc_checkSubmitBtnReady();
  gc_CheckSizeSwatchClk();
  $("#tmessage-gc").on("keydown", function () {
    var totalLeft = 200 - $("#tmessage-gc").val().length;
    $("#msg-chars-left").html(totalLeft + " characters left.");
  });
});

function gc_CheckSizeSwatchClk() {
  $(".swatchLbl").on("click tap", function () {
    //console.log("gc size click");
    gc_checkSubmitBtnReady();
  });
}

function gc_checkSubmitBtnReady() {
  if (pinkblush.cartobj.variantid == 0) {
    pinkblush.cartobj.size = "";
    $(".product-form__item--submit #AddToCart-product-giftcard-template").html("Please Select An Amount");
    $(".product-form__item--submit .product-form__cart-submit-gc").prop("disabled", true);
    $(".slVariant").html("");
  } else {
    $(".atc-error").html("");
    $(".product-form__item--submit #AddToCart-product-giftcard-template").html("Add To Cart");
    $(".product-form__item--submit .product-form__cart-submit-gc").prop("disabled", false);
  }
}

$(".amount-swatches-gc .swatchLbl").on("click tap", function () {
  pinkblush.cartobj.variantid = $(this).data("variantid");
  pinkblush.cartobj.gc_amount = $(this).data("price");
  gc_checkSubmitBtnReady();
});

function checkGCInputErrors() {
  var error = false;

  if ($("#to-name").val().length < 1) {
    $("#to-name").addClass("input--error");
    $(".t-name-error").html("Please enter a name.");
    error = true;
  } else {
    $(".t-name-error").html("&nbsp;");
    $("#to-name").removeClass("input--error");
  }

  if ($("#from-name").val().length < 1) {
    $(".f-name-error").html("Please enter a name.");
    $("#from-name").addClass("input--error");
    error = true;
  } else {
    $(".f-name-error").html("&nbsp;");
    $("#from-name").removeClass("input--error");
  }

  if ($("#to-email").val().length < 1 || !validateEmail($("#to-email").val())) {
    $(".t-email-error").html("Please enter a valid email");
    $("#to-email").addClass("input--error");
    error = true;
  } else {
    $(".t-email-error").html("&nbsp;");
    $("#to-email").removeClass("input--error");
  }

  return error;
}

$(document).ready(function () {
  $("#to-name").on("keydown", function () {
    $(".t-name-error").html("&nbsp;");
    $("#to-name").removeClass("input--error");
  });
  $("#to-email").on("keydown", function () {
    $(".t-email-error").html("&nbsp;");
    $("#to-email").removeClass("input--error");
  });
  $("#from-name").on("keydown", function () {
    $(".f-name-error").html("&nbsp;");
    $("#from-name").removeClass("input--error");
  });
});

function validateEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}